import Route from '@ember/routing/route';

import type { ProgramsProgramCohortCoachingModel } from '../coaching.ts';

export interface ProgramsProgramCohortCoachingCoacheesModel {
  coaching: ProgramsProgramCohortCoachingModel['coaching'];
  cohortId: string;
}

/**
 * Partnership, session, and best-match oversight for a cohort's enrolled
 * coachees. Reuses the parent coaching route's already-resolved coaching
 * record; the enrolled coachees (plans) are fetched paginated by
 * EnrolledCoachees, so this route stays light.
 */
export default class ProgramsProgramCohortCoachingCoacheesRoute extends Route<ProgramsProgramCohortCoachingCoacheesModel> {
  model(): ProgramsProgramCohortCoachingCoacheesModel {
    const parent = this.modelFor(
      'programs.program.cohort.coaching'
    ) as ProgramsProgramCohortCoachingModel;

    return { coaching: parent.coaching, cohortId: parent.cohort.id! };
  }
}
